import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Container } from "react-bootstrap";

import "./app.css";
import Home from "./components/pages/Home.js";
import Footer from "./components/general/Footer.js";
import Projects from "./components/pages/Projects";
import PrivacyPolicyPage from "./components/pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./components/pages/TermsAndConditionsPage";
import RefundPolicyPage from "./components/pages/RefundPolicyPage";
import ContactMeCard from "./components/general/ContactMeCard.js";
import PageNotFound from "./components/pages/PageNotFound";
import MobileDevelopmentPage from "./components/pages/MobileDevelopmentPage";
import WebDevelopmentPage from "./components/pages/WebDevelopmentPage";
import SoftwareDevelopmentPage from "./components/pages/SoftwareDevelopmentPage";

function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/contact-me">
            <Home />
            <ContactMeCard show={true} />
          </Route>
          <Route exact path="/privacy-policy">
            <PrivacyPolicyPage />
          </Route>
          <Route exact path="/terms-and-conditions">
            <TermsAndConditionsPage />
          </Route>
          <Route exact path="/refund-policy">
            <RefundPolicyPage />
          </Route>

          <Route exact path="/projects/mobile-development">
            <MobileDevelopmentPage />
          </Route>
          <Route exact path="/projects/web-development">
            <WebDevelopmentPage />
          </Route>
          <Route exact path="/projects/software-development">
            <SoftwareDevelopmentPage />
          </Route>
          <Route exact path="/projects">
            <Projects />
          </Route>
          <Route path="*">
            <PageNotFound />
          </Route>
        </Switch>
        <div className="footer">
          <Container style={{ height: "100%" }}>
            <Footer />
          </Container>
        </div>
      </div>
    </Router>
  );
}

export default App;
